import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';
import { Button } from '/imports/ui/Button';

const DevToolSectionStyled = styled.section`
  padding: 1rem;
  border: ${css.border};
  border-radius: ${css.borderRadius};
`;

interface DevToolSectionProps {
  title?: string;
  description?: string;
  onRun?(): void;
  buttonText?: string;
  loading?: boolean;
  children?: React.ReactNode;
}

/** Card wrapper for a dev tool with optional title, description, run button, and children. */
export const DevToolSection = (props: DevToolSectionProps) => {
  return (
    <DevToolSectionStyled>
      {props.title && <h2>{props.title}</h2> || null}
      {props.description && <p dangerouslySetInnerHTML={{ __html: props.description }} /> || null}
      {
        props.onRun ?
          <div>
            <Button onClick={() => props.onRun?.()} disabled={props.loading}>{props.loading ? 'Running...' : (props.buttonText || 'Run')}</Button>
          </div>
          :
          null
      }
      {props.children || null}
    </DevToolSectionStyled>
  );
};

